import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';

function CreateLeadToDo({ show, currentToDo, onFormToDoSubmit, onClose, data }) {


    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const [formData, setFormData] = useState({
        ID: 0, LeadID: '0', Text: "", Completed: "0"
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (currentToDo) {
           
            setFormData({
                ID: currentToDo.ID, LeadID: currentToDo.LeadID, Text: currentToDo.Text, Completed: currentToDo.Completed.toString()
            });
        }
        else {
            setFormData({
                 ID: 0, LeadID: '0', Text: "", Completed: "0"
            });
        }
    }, [currentToDo]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Description: content
        });
    };

    const handleRadioChange = (event) => {
        const { value } = event.target;
        // Create a base object with `type` updated
        let updatedFormData = {
            ...formData,
            snt_CommunicationType: value
        };
        setFormData(updatedFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        setErrors({});
        let validationErrors = {};

        if (!formData.Text || !formData.Text.trim()) {
            validationErrors.Text = 'This field is required';
        }
       

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const newEntries = [];
        const newEntry = {
            ...formData,
            ID: formData.ID,
            Text: formData.Text,
            Completed: formData.Completed
            
        };

        newEntries.push(newEntry);
        onFormToDoSubmit(newEntries);
    };
    
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerHistoryModal show d-block" id="customerHistoryModal" tabIndex="-1" aria-labelledby="customerHistoryModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentToDo ? "Edit Todo" : "Add Todo"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label htmlFor="Text" className="col-sm-2 col-form-label">Todo:<span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-10">
                                        <input type="text" className="form-control" name="Text" value={formData.Text} onChange={handleFieldChange}/>
                                            {errors.Text && <div style={{ color: 'red' }}>{errors.Text}</div>}
                                        </div>

                                    </div>
                                    
                                   
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <i className="icofont-save" aria-hidden="true">
                                            {currentToDo ? " Update" : " Save"}
                                        </i>
                                    </button>
                                    <button className="btn btn-secondary" type="button" aria-label="Close" onClick={onClose}>
                                        <i className="icofont-close" aria-hidden="true"> Close</i>
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateLeadToDo;
